import * as api from '../api'
import useInvalidate from '../useInvalidate'
import useApiMutation from './useApiMutation'

type DeleteCommentArguments = {
  commentUuid: string
  permanent?: boolean
} & ({ learningItemUuid: string } | { groupUuid: string })

export default function useDeleteComment() {
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async (data: DeleteCommentArguments) => {
      const payload = {
        permanent: data.permanent ? 'true' : undefined,
      }

      if ('groupUuid' in data) {
        await api.del(
          `group/${encodeURIComponent(data.groupUuid)}/comment/${encodeURIComponent(data.commentUuid)}`,
          payload
        )
      } else {
        await api.del(
          `course/${encodeURIComponent(data.learningItemUuid)}/comment/${encodeURIComponent(data.commentUuid)}`,
          payload
        )
      }

      await invalidate.comments()
    },
  })
}
